import { makeStyles } from '@material-ui/core';
import { BorderClear } from '@material-ui/icons';

export const useStyles = makeStyles(() => ({
  messagePreview: {
    height: 'calc(100vh - 150px)',
    position: 'relative',
    overflow: 'auto',
  },
  messageContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  subjectContener: {
    borderBottom: '1px solid #2C2D3E4D',
  },
  subject: {
    color: '#2C2D3E',
    fontWeight: 700,
    fontSize: '18px',
    margin: '15px',
  },
  messageContener: {
    margin: '15px',
    color: '#2C2D3E',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  messageHeader: {
    borderBottom: '1px solid #2C2D3E4D',
    paddingBottom: '10px',
  },
  messageHead: {
    display: 'flex',
  },
  sender: {
    fontSize: '16px',
    fontWeight: 600,
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: 'calc(50vh - 200px)',
    textOverflow: 'ellipsis',
    marginBottom: '10px',
  },
  recipient: {
    fontSize: '14px',
  },
  sentDate: {
    fontSize: '14px',
    paddingTop: '3px',
  },
  actionIcon: {
    fontSize: '20px',
    marginRight: '-10px',
  },
  content: {
    fontSize: '14px',
    padding: '15px 0 15px 0',
    overflowWrap: 'anywhere',
  },
  buttonsFooter: {
    position: 'absolute',
    bottom: '15px',
    left: '15px',
  },
  specialCaseRow: {
    display: 'flex',
    marginTop: '10px',
  },
  specialCaseType: {
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  specialCaseTypeLabel: {
    fontWeight: 600,
  },
  goToCardButton: {
    color: '#3C419A',
    borderColor: '#3C419A',
    position: 'relative',
    top: '-10px',
    minWidth: '135px',
    '@media (max-width: 1100px)': {
      fontSize: '11px',
      minWidth: '120px',
    },
  },
  buttonContainer: {
    width: '100%',
    justifyContent: 'flex-end',
    display: 'flex',
  },
}));
